//---- Automatically generated, don't update this part ----

import Transform from "@ember-data/serializer/transform";
import Performer from "parog-web/models/performer";

export default class PerformersTransform extends Transform {
  override deserialize(serialized) {
    return serialized?.map(performer => new Performer(performer)) || [];
  }

  override serialize(deserialized) {
    return deserialized?.map(performer => performer.toJson()) || [];
  }
  //---- End of generated code ----
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/transform" {
  export default interface ModelRegistry {
    performers: PerformersTransform;
  }
}
